"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var common_1 = require("@scuf/common");
var Section = /** @class */ (function (_super) {
    __extends(Section, _super);
    function Section(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleExpanded = function () {
            _this.setState(function (_a) {
                var expanded = _a.expanded;
                return ({ expanded: !expanded });
            });
        };
        _this.genClasses = function () {
            var className = _this.props.className;
            var classes = 'filter-section';
            if (_this.state.expanded) {
                classes += ' expanded';
            }
            if (className) {
                classes += ' ' + className;
            }
            return classes;
        };
        _this.state = { expanded: false };
        return _this;
    }
    Section.prototype.render = function () {
        var _a = this.props, label = _a.label, rest = __rest(_a, ["label"]);
        return (React.createElement("div", __assign({ className: this.genClasses() }, rest),
            React.createElement("div", { className: "section-label", onClick: this.toggleExpanded },
                React.createElement("div", { className: "section-label-text" }, label),
                React.createElement(common_1.Icon, { name: "caret-up", className: "section-label-icon", rotated: this.state.expanded ? 0 : 180 })),
            React.createElement("div", { className: "section-content" }, this.props.children)));
    };
    return Section;
}(React.Component));
exports.default = Section;
//# sourceMappingURL=Section.js.map